import axios from 'axios';

export const getMyHubsSummaryAsync = async () => {
  const { data } = await axios.get(`/my-hubs/summary`);

  return data;
};

export const getMyHubsTravelAsync = async () => {
  const { data } = await axios.get(`/my-hubs/revolution`);

  return data;
};

export const getMyHubsAccessPacksAsync = async () => {
  const { data } = await axios.get(
    `/products/travelution-access-packs/my-orders/paid`
  );

  return data;
};

export const getMyHubsSubscriptionsAsync = async () => {
  const { data } = await axios.get(
    `/products/travelution-subscriptions/my-orders/paid`
  );

  return data;
};

export const getMyHubsSaveAndTravelSubscriptionsAsync = async () => {
  const { data } = await axios.get(
    `/products/travelution-save-and-travel-subscriptions/my-orders/paid`
  );

  return data;
};

export const getMyHubsSubscriptionsBundleAsync = async () => {
  const { data } = await axios.get(
    `/products/travelution-subscription-bundles/my-orders/paid`
  );

  return data;
};

export const getMyHubsSuperSalesAsync = async () => {
  const { data } = await axios.get(`/my-hubs/travelution-super-sale`);

  return data;
};

export const getRevolutionSubscriptionsAsync = async () => {
  const { data } = await axios.get(
    `/products/travelution-getrevolution-subscriptions/my-orders/paid`
  );

  return data;
};

export const getMyHubsVipAsync = async () => {
  const { data } = await axios.get(
    `/products/travelution-no-renewal-pass/my-orders/paid`
  );

  return data;
};

export const sendGiftAsync = async ({
  giftOrderId,
  recipientUserId
}: {
  giftOrderId: number;
  recipientUserId: string;
}) => {
  const { data } = await axios.post(
    `/products/travelution-subscription-bundles/my-orders/${giftOrderId}/gift`,
    {
      recipientUserId: Number(recipientUserId)
    }
  );

  return data;
};

export const getMyHubsGoldenCardAsync = async () => {
  const { data } = await axios.get(
    `/products/travelution-golden-cards/my-orders/paid`
  );

  return data;
};
